import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box,Card, CardContent, Typography, Grid, CardActionArea, CircularProgress } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPercentage, faChartPie, faRandom } from '@fortawesome/free-solid-svg-icons';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { API_BASE_URL } from '../../constants/constants';
import BackButton from '../../components/BackButton';

const cardData = [
  {
    title: 'Set GST',
    icon: faPercentage,
    path: 'set-gst',
    modules: [3210],
  },
  {
    title: 'Set Commission %',
    icon: faChartPie,
    path: 'set-all-div',
    modules: [3211],
  },
  {
    title: 'Set CASHBACK SEQUENCE',
    icon: faRandom,
    path: 'set-random',
    modules: [3212],
  },
  {
    title: 'Set Advertisement Price',
    icon: faRandom,
    path: 'set-Ad-price',
    modules: [3213],
  },
];

const SetDivisionsManagement = () => {
  const [userModules, setUserModules] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchUserPrivileges = useCallback(async (userId) => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${API_BASE_URL}/privileges/modules/${userId}`, {
        timeout: 5000
      });
      
      if (response.status === 200 && response.data.modules) {
        setUserModules(response.data.modules);
      } else {
        setError('No modules found for user');
      }
    } catch (error) {
      setError('Failed to load user privileges');
      console.error('Error fetching user privileges:', error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (!token) {
      setError('Please login to continue');
      setIsLoading(false);
      return;
    }

    try {
      const decodedToken = jwtDecode(token);

      if (decodedToken.level === 1) {
        setUserModules(cardData.flatMap(card => card.modules));
        setIsLoading(false);
      } else {
        fetchUserPrivileges(decodedToken.userId);
      }
    } catch (error) {
      setError('Invalid authentication token');
      setIsLoading(false);
    }
  }, [fetchUserPrivileges]);

  const handleCardClick = useCallback((path) => {
    navigate(path);
  }, [navigate]);

  const hasAccess = useCallback((modules) => {
    return modules.some(moduleId => userModules.includes(moduleId));
  }, [userModules]);

  if (isLoading) {
    return (
      <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '50vh' }}>
        <CircularProgress />
      </Grid>
    );
  }

  if (error) {
    return (
      <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '50vh' }}>
        <Typography color="error">{error}</Typography>
      </Grid>
    );
  }

  if (userModules.length === 0) {
    return (
      <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '50vh' }}>
        <Typography variant="h6" color="error">
          You are not allowed to use this page, ask your admin.
        </Typography>
      </Grid>
    );
  }

  return (
     <Box sx={{ position: 'relative', padding: 2 }}>
                  {/* Place BackButton outside the Grid */}
                  <BackButton />
                  <br/>  <br/>
    <Grid container spacing={3} justifyContent="center" alignItems="center" sx={{ padding: 3 }}>
      {cardData.map((card) => (
        hasAccess(card.modules) && (
          <Grid item xs={12} sm={6} md={4} key={card.title}>
            <Card
              elevation={3}
              sx={{
                maxWidth: 225,
                backgroundColor: 'white',
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  backgroundColor: 'primary.main',
                  color: 'white',
                  transform: 'translateY(-4px)',
                  '& .MuiTypography-root': { color: 'white' },
                  '& .fa-icon': { color: 'white' },
                },
              }}
            >
              <CardActionArea onClick={() => handleCardClick(card.path)}>
                <CardContent sx={{ textAlign: 'center', padding: 3 }}>
                  <FontAwesomeIcon
                    icon={card.icon}
                    size="5x"
                    className="fa-icon"
                    style={{ color: 'orange' }}
                  />
                  <Typography 
                    gutterBottom 
                    variant="h5" 
                    component="div" 
                    sx={{ marginTop: 2, fontWeight: 500 }}
                  >
                    {card.title}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        )
      ))}
    </Grid>
    </Box>
  );
};

export default SetDivisionsManagement;